<template>
  <div style="padding: 20px;">
    <h3>饲养信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="动物类型">
            <a-select
              placeholder="请选择"
              v-decorator="['animalType',{rules:[{required: true, message: '请选择动物类型'}]}]"
              @change="changeFeedVarietyList"
            >
              <a-select-option v-for="el in animalTypeList" :key="el.animalTypeId" :value="el.animalTypeName ">
                {{ el.animalTypeName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲养品种">
            <a-select
              placeholder="请选择"
              v-decorator="['feedVariety',{rules:[{required: true, message: '请选择饲养品种'}]}]"
            >
              <a-select-option v-for="el in feedVarietyList" :key="el.id" :value="el.name">
                {{ el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲养阶段">
            <a-select
              placeholder="请选择"
              v-decorator="['feedStage',{rules:[{required: true, message: '请选择饲养阶段'}]}]"
              @change="proportionDiarrhea = ''"
            >
              <a-select-option v-for="el in stageList" :key="el.stageId" :value="el.stageName">
                {{ el.stageName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="性别">
            <a-radio-group v-decorator="['sex',{rules:[{required: true, message: '请选择饲养阶段'}]}]">
              <a-radio v-for="el in sexList" :key="el.sexId" :value="el.sexName">{{ el.sexName}}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲养模式">
            <a-radio-group v-decorator="['feedStyle',{rules:[{required: true, message: '请选择饲养模式'}]}]">
              <a-radio v-for="el in feedingPatternList" :key="el.feedingPatternId" :value="el.feedingPatternName">
                {{ el.feedingPatternName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料品牌">
            <a-select
              placeholder="请选择"
              v-decorator="['feedBrand',{
                rules:[{required: true, message: '请选择饲料品牌'}],
                initialValue:`新希望`
              }]"
              @change="handleChange"
            >
              <a-select-option v-for="el in feedBrandList" :key="el.varietyDepotCode" :value="el.varietyDepotName">
                {{ el.varietyDepotName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料型号" >
            <a 
              v-if="form.getFieldValue('feedBrand') == '新希望' && !form.getFieldValue('feedModel')" 
              v-decorator="['feedModel',{rules:[{required: true, message: '请选择配方'}],}]"
              @click="handleClick()">选择配方</a>
            <a 
              v-else-if="form.getFieldValue('feedBrand') == '新希望' && form.getFieldValue('feedModel')" 
              v-decorator="['feedModel',{rules:[{required: true, message:'请选择配方'}],}]"
              @click="handleClick()">{{form.getFieldValue('feedModel')}}</a>
            <a-input 
              v-else placeholder="请输入" 
              :maxLength="50"
              v-decorator="['feedModel',{rules:[{required: true, message: '请输入饲料型号'}],}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料定位">
            <a-radio-group v-decorator="['feedTarget',{rules:[{required: true, message: '请选择饲料定位'}],}]">
              <a-radio v-for="el in productPositionList" :key="el.productPositionId" :value="el.productPositionName">
                {{ el.productPositionName}}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料终端价格（元/吨）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="100000"
              v-decorator="['feedTerminalPrice',{rules:[{required: true, message: '请输入饲料终端价格'}],}]"
              :precision="2"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="购进成本（元/头）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="100000"
              v-decorator="['bugPrice',{rules:[{required: true, message: '请输入购进成本'}],}]"
              :precision="2"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="出售价格（元/kg）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="1000"
              v-decorator="['salePrice',{rules:[{required: true, message: '请输入出售价格'}],}]"
              :precision="2"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item 
            v-if="form.getFieldValue('feedStage') == '犊牛' || form.getFieldValue('feedStage') == '羔羊'" 
            label="腹泻比例（%）"
          >
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="100"
              v-model="proportionDiarrhea"
              :precision="2"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <div style="margin-bottom: 10px">实证阶段</div>
          <a-table 
            :columns="inputFeedInfoRuminateColumns" 
            :data-source="feedInfoList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }"
          >
            <span slot="dayTitle"><span style="color: red">*</span> 日期</span>
            <span slot="day" slot-scope="text, record ,index">
              <a-date-picker 
                v-model="record.day" 
                valueFormat="YYYY-MM-DD" 
                :disabled-date="index == 0 ? disabledStartDate : disabledEndDate"
              />
            </span>
            <span slot="numTitle"><span style="color: red">*</span> 数量（头）</span>
            <span slot="num" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="100000"
                v-model="record.num"
                @blur="verificationLegal(record,'num')"
              />
            </span>
            <span slot="weightTitle"><span style="color: red">*</span> 均重（kg/头）</span>
            <span slot="weight" slot-scope="text, record">
              <a-input-number
                placeholder="请输入"
                :min="1"
                :max="1000"
                v-model="record.weight"
                :precision="2"
                @blur="verificationLegal(record,'weight')"
              />
            </span>
          </a-table>
        </a-col>
        <a-col :span="24">
          <div style="margin: 10px 0px"><br>平均日饲喂情况</div>
          <a-button icon="plus" style="margin-bottom: 10px" @click="handleAddClick">添加原料</a-button>
          <a-table 
            :columns="dailyFeedColumns" 
            :data-source="feedStageList" 
            :pagination="false" 
            :rowKey="(record, index) => { return index }"
          >
            <span slot="weightTitle"><span style="color: red">*</span> 重量（kg/天）</span>
            <span slot="weight" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="300"
                v-model="record.weight"
                :precision="2"
              />           
            </span>
            <span slot="priceTitle"><span style="color: red">*</span> 单价（元/kg）</span>
            <span slot="price" slot-scope="text, record">
              <a-input-number
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="300"
                v-model="record.price"
                :precision="2"
              />
            </span>
            <span slot="x" slot-scope="text, record,index">
              <a @click="deleteMaterial(index)">删除</a>
            </span>
          </a-table>
          <br>
        </a-col>
      </a-row>
    </a-form>
    <formula-modal 
      ref="formulaModal" 
      :visible="visible" 
      @isShow="isShow" 
      @getSelect="getSelect" 
      :selectFactory="selectFactory"
      :factoryId="factoryId"
    />
    <material-modal 
      ref="materialModal" 
      :visible="materialvisible" 
      @isShow="materialisShow" 
      @getSelect="materialGetSelect" 
      :materialList="materialList"
    />
  </div>
</template>

<script>
import {inputFeedInfoRuminateColumns,dailyFeedColumns} from '../Columns'
import {animalTypeList,sexList,feedingPatternList, productPositionList} from './Lists'
import MaterialModal from'./MaterialModal.vue'
import FormulaModal from'./FormulaModal.vue'

import moment from 'moment';

export default {
  props:['selectFactory','factoryId','feedInfoList','feedStageList','ruminationLineFeedInfo'],
  components:{MaterialModal,FormulaModal},
  data(){
    return{
      form: this.$form.createForm(this, { name: 'feedInfo' }),
      animalTypeList,
      stageList:[],
      sexList,
      feedingPatternList,
      nhfFormulaId : '',
      modelCode:'',
      modelName:'',
      proportionDiarrhea:'',
      productPositionList,
      inputFeedInfoRuminateColumns,
      dailyFeedColumns,
      feedBrandList:[],
      feedVarietyList:[],
      visible: false,
      materialvisible: false,
      materialList:[],
    }
  },
  mounted() {
    this.feedBrandGet()
    if(this.$route.query.copyId) this.convert()
    this.form.setFieldsValue(this.ruminationLineFeedInfo)
    this.proportionDiarrhea = this.ruminationLineFeedInfo.proportionDiarrhea
    this.nhfFormulaId = this.ruminationLineFeedInfo.nhfFormulaId
    this.modelCode = this.ruminationLineFeedInfo.modelCode
    this.modelName = this.ruminationLineFeedInfo.modelName
    if(this.form.getFieldValue('animalType')) this.getFeedVarietyList(this.form.getFieldValue('animalType'))
  },
  methods:{
    sendData(){
      this.$emit('setFeedInfo', {
        feedInfoList:this.feedInfoList,
        feedStageList:this.feedStageList,
        nhfFormulaId:this.nhfFormulaId,
        modelCode:this.modelCode,
        modelName:this.modelName,
        proportionDiarrhea:this.proportionDiarrhea
      })
    },
    handleChange(){
      this.nhfFormulaId = ''
      this.modelCode = ''
      this.modelName = ''
      this.form.setFieldsValue({'feedModel':''})
    },
    handleClick() {
      this.visible = true
      this.$refs.formulaModal.reset()
    },
    handleAddClick(){
      this.getMaterialList()
      this.materialvisible = true
    },
    async getMaterialList(){
      this.$http.get("/sat-collect/ruminationLine/dryfeed").then(res =>{
        let { success,data } = res
        if(success){
          for(let a in this.feedStageList){
            for(let b in data){
              if(data[b].value == this.feedStageList[a].feedName) data.splice(b,1)
            }
          }
          this.materialList = data
        }
      })
    },
    isShow(val){
      this.visible = val
    },
    materialisShow(val){
      this.materialvisible = val
    },
    getSelect(val){
      this.form.setFieldsValue({'feedModel':val[0].formulaName})
      this.nhfFormulaId = val[0].id
    },
    materialGetSelect(val){
      val.forEach(el => {
        this.feedStageList.push({
          name:el.name,
          feedName:el.value,
          dryPercentage:el.percentage,
          weight:'',
          price:''
        })
      });
    },
    async feedBrandGet() {
      const res = await this.$http.get("/sat-ruminants/varietydepot/list", { params:{type:2, size:-1, labelCode:'ruminant'} })
      let { success, data } = res;
      if (success) this.feedBrandList = data.records 
    },
    convert(){
      this.feedInfoList[0].day = this.ruminationLineFeedInfo.intoDay
      this.feedInfoList[0].num = this.ruminationLineFeedInfo.intoNum
      this.feedInfoList[0].weight = this.ruminationLineFeedInfo.avgInitialWeight
      this.feedInfoList[1].day = this.ruminationLineFeedInfo.outDay
      this.feedInfoList[1].num = this.ruminationLineFeedInfo.outNum
      this.feedInfoList[1].weight = this.ruminationLineFeedInfo.avgEndWeight
    },
    disabledStartDate(startValue) {
      const endValue = moment(this.feedInfoList[1].day,'YYYY-MM-DD')
      if (!startValue || !endValue) return false
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = moment(this.feedInfoList[0].day,'YYYY-MM-DD')
      if (!endValue || !startValue) return false
      return startValue.valueOf() >= endValue.valueOf()
    },
    verificationLegal(record, title) {
      if(this.feedInfoList[0][title] && this.feedInfoList[1][title]){
        if(title == 'num' && record[title] && this.feedInfoList[0][title] < this.feedInfoList[1][title]) {
          this.$message.error('出栏数量不得大于入栏数量，请重新输入！')
          record[title] = ''
        }
        else if(title != 'num' && record[title] && this.feedInfoList[0][title] > this.feedInfoList[1][title]){
          if(title == 'weight') this.$message.error('结束体重不得小于初始体重，请重新输入！')
          record[title] = ''
        }
      }
    },
    async getFeedVarietyList(value){
      let {VarietyDepotCode,LabelCode,stageList} =this.animalTypeList.find(item => item.animalTypeName == value)
      this.stageList = stageList
      let res = await this.$http.get("/sat-ruminants/animalvariety/list", { params:{VarietyDepotCode,LabelCode,size: -1}})
      this.feedVarietyList = res.data.records
    },
    async changeFeedVarietyList(value){
      this.getFeedVarietyList(value)
      this.form.setFieldsValue({'feedVariety':undefined,'feedStage':undefined})
    },
    deleteMaterial(index){
      this.feedStageList.splice(index,1);
    }
  }
}
</script>

<style>

</style>